export const isExtremeTab = (tabs, selectedTab, type) => {
  const tabIndices = Object.keys(tabs).map(key => parseInt(key, 10));
  const extremeIndex = type === 'min'
    ? Math.min(...tabIndices)
    : Math.max(...tabIndices);
  return selectedTab === extremeIndex;
}


export const getTabByDirection = (currentIndex, tabs, direction) => {
  const tabArray = Object.values(tabs);
  
  switch(direction) {
    case 'left': {
      const tabsAbove = tabArray.filter(tab => tab.index < currentIndex);
      return tabsAbove.sort((a, b) => b.index - a.index)[0] || null;
    }
    case 'right': {
      const tabsBelow = tabArray.filter(tab => tab.index > currentIndex);
      return tabsBelow.sort((a, b) => a.index - b.index)[0] || null;
    }
    default: {
      return null;
    }
  }
};